import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1886.76222 L1436.68082,1758.65352 L1072.15334,1394.12605 C1181.62805,1293.96834 1309.73675,1174.01201 1435.5162,1047.06794 L1791.8913,1403.44304 L1920,1886.76222 Z M396.671115,188.739657 L580.681791,372.750333 L407.152736,547.444013 L221.977435,362.268712 L396.671115,188.739657 Z M546.907679,877.032754 C648.230013,764.064175 771.680214,632.461603 902.118161,504.352905 L444.420721,46.6554646 C418.798981,21.033725 375.707873,19.8691005 348.921509,46.6554646 L78.7286182,314.519107 C65.9177484,326.165352 58.9300012,343.63472 58.9300012,362.268712 C58.9300012,379.73808 65.9177484,397.207448 78.7286182,408.853693 L546.907679,877.032754 Z M718.922722,1545.99308 C660.342108,1676.89688 389.217518,1738.27259 213.009827,1760.74985 C241.543128,1687.61143 271.706903,1576.73917 271.706903,1433.9562 C271.706903,1355.69344 327.14303,1273.47094 400.863763,1242.84132 C422.525779,1233.75725 444.88657,1229.21521 467.829674,1229.21521 C527.574912,1229.21521 590.464637,1259.49545 650.675725,1318.07606 C722.765983,1409.61555 745.709086,1486.36431 718.922722,1545.99308 L718.922722,1545.99308 Z M1913.94395,184.896396 C1916.15674,129.110881 1893.56302,94.4050704 1868.29067,69.0162556 C1848.9579,49.6834884 1814.95087,26.7403852 1758.00073,29.3025591 C1437.26313,42.3463539 625.053985,960.303408 491.005702,1114.26677 C445.35242,1110.65644 399.699139,1117.17833 355.909256,1135.34648 C237.816329,1184.72656 155.24445,1307.47798 155.24445,1433.9562 C155.24445,1661.29091 67.5482227,1794.52396 66.849448,1795.68858 L0,1893.16766 L117.976465,1886.64576 C178.420478,1883.38481 711.585588,1846.93206 825.252942,1593.74269 C846.449108,1546.34247 851.107606,1495.79777 840.742448,1442.45796 C1003.09111,1301.07255 1901.48247,504.003518 1913.94395,184.896396 L1913.94395,184.896396 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMaterialsRequiredLightSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMaterialsRequiredLightSolid, _Component);

  var _super = _createSuper(IconMaterialsRequiredLightSolid);

  function IconMaterialsRequiredLightSolid() {
    _classCallCheck(this, IconMaterialsRequiredLightSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMaterialsRequiredLightSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconMaterialsRequiredLightSolid /> is deprecated. Please use <IconMaterialsRequiredSolid /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMaterialsRequiredLight",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMaterialsRequiredLightSolid.displayName = "IconMaterialsRequiredLightSolid";
  return IconMaterialsRequiredLightSolid;
}(Component);

IconMaterialsRequiredLightSolid.glyphName = 'materials-required-light';
IconMaterialsRequiredLightSolid.variant = 'Solid';
IconMaterialsRequiredLightSolid.deprecated = true;
IconMaterialsRequiredLightSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMaterialsRequiredLightSolid;
export { IconMaterialsRequiredLightSolid };